"use client";

import type { LucideIcon } from "lucide-react";
import {
  Armchair,
  Clock,
  Coffee,
  Cookie,
  GraduationCap,
  House,
  Monitor,
  Shuffle,
  Sparkles,
  Store,
  Sun,
  TrainFront,
  UserCheck,
  UtensilsCrossed,
} from "lucide-react";
import type { ReactElement } from "react";
import type { CareersBenefitIconKey } from "./careers-benefits-copy";
import { CAREERS_BENEFITS } from "./careers-benefits-copy";
import { useCareersLanguage } from "./careers-language-context";

const BENEFIT_ICONS: Record<CareersBenefitIconKey, LucideIcon> = {
  house: House,
  clock: Clock,
  shuffle: Shuffle,
  userCheck: UserCheck,
  sparkles: Sparkles,
  sun: Sun,
  graduationCap: GraduationCap,
  monitor: Monitor,
  armchair: Armchair,
  coffee: Coffee,
  cookie: Cookie,
  trainFront: TrainFront,
  store: Store,
  utensils: UtensilsCrossed,
};

/** Three columns: icon, headline, body. */
export function CareersBenefitsGrid(): ReactElement {
  const { lang } = useCareersLanguage();

  return (
    <ul className="c2-ben-grid">
      {CAREERS_BENEFITS.map((item) => {
        const Icon: LucideIcon = BENEFIT_ICONS[item.icon];
        return (
          <li className="c2-ben-item" key={item.icon}>
            <Icon
              className="c2-ben-icon"
              size={26}
              strokeWidth={1.7}
              aria-hidden={true}
            />
            <h3 className="c2-ben-title">{item.title[lang]}</h3>
            <p className="c2-ben-text">{item.body[lang]}</p>
          </li>
        );
      })}
    </ul>
  );
}
